import { Restaurant } from "api-types";

import { useState } from "react";

import { restaurantFromDoc } from "@dashboard/store/backendApis/restaurantApi";
import { FetchCallbacks } from "@dashboard/types/global";
import type {
  CreateRestaurantRequest,
  FirestoreRestaurantDocument,
} from "@dashboard/types/restaurant";

import { useAxiosClient } from "../../context";

export const useCreateRestaurant = ({
  onSuccess,
  onError,
  onFinish,
}: FetchCallbacks<Restaurant, Error>) => {
  const [loading, setLoading] = useState(false);

  const axiosClient = useAxiosClient({ withAuth: true });

  const createRestaurant = async (
    createRestaurantRequest: CreateRestaurantRequest
  ) => {
    setLoading(true);
    try {
      const response = await axiosClient.post<Restaurant>(
        "/create-restaurant",
        createRestaurantRequest
      );

      if (response.status !== 200) {
        onError?.(
          new Error(
            `Received a non-200 response from the backend: ${response.status}`
          )
        );
      } else {
        onSuccess?.(
          restaurantFromDoc(response.data as FirestoreRestaurantDocument)
        );
      }
    } catch (error) {
      onError?.(error as Error);
    } finally {
      setLoading(false);
      onFinish?.();
    }
  };

  return { createRestaurant, loading };
};
